export default "<a class=\"app_tooltip\" [matTooltip]=\"message\" [matTooltipPosition]=\"position\">\n  <i class=\"fas fa-2x\" [ngClass]=\"icon\" ></i>\n</a>";